import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/layout/Layout";
import ScrollToTop from "@/components/site/ScrollToTop";
import Home from "@/pages/Home";
import ServiceDetail from "@/pages/ServiceDetail";
import CityServicePage from "@/pages/CityServicePage";
import RebatesGuide from "@/pages/RebatesGuide";
import ProjectsList from "@/pages/ProjectsList";
import ProjectDetail from "@/pages/ProjectDetail";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import AboutUs from "@/pages/AboutUs";
import ReviewsPage from "@/pages/ReviewsPage";
import Rebates from "@/pages/Rebates";
import LegalPage from "@/pages/LegalPage";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services/ev-charger-installation/:city" element={<CityServicePage serviceSlug="ev-charger-installation" />} />
            <Route path="/services/panel-upgrades/:city" element={<CityServicePage serviceSlug="panel-upgrades" />} />
            <Route path="/services/emergency/:city" element={<CityServicePage serviceSlug="emergency" />} />
            <Route path="/services/security/:city" element={<CityServicePage serviceSlug="security" />} />
            <Route path="/services/general-electrical/:city" element={<CityServicePage serviceSlug="general-electrical" />} />
            <Route path="/services/commercial-wiring/:city" element={<CityServicePage serviceSlug="commercial-wiring" />} />
            <Route path="/services/lighting/:city" element={<CityServicePage serviceSlug="lighting" />} />
            <Route path="/services/:slug" element={<ServiceDetail />} />
            <Route path="/guides/bc-ev-charger-rebates-2026" element={<RebatesGuide variant="ev" />} />
            <Route path="/guides/electrical-panel-upgrade-cost-bc-2026" element={<RebatesGuide variant="panel" />} />
            <Route path="/projects" element={<ProjectsList />} />
            <Route path="/projects/:slug" element={<ProjectDetail />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/reviews" element={<ReviewsPage />} />
            <Route path="/rebates" element={<Rebates />} />
            <Route path="/privacy-policy" element={<LegalPage page="privacy-policy" />} />
            <Route path="/terms-of-use" element={<LegalPage page="terms-of-use" />} />
            <Route path="/cookie-policy" element={<LegalPage page="cookie-policy" />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#141414",
            border: "1px solid #262626",
            color: "#fff",
            borderRadius: 0,
          },
        }}
      />
    </div>
  );
}

export default App;
